import { MyPortfolioContainer } from '@/features/my-portfolio/MyPortfolioContainer'

export function MyPortfolioPage() {
  return <MyPortfolioContainer />
}
